import { render, staticRenderFns } from "./PostSaveModal.vue?vue&type=template&id=147eb320&scoped=true&"
import script from "./PostSaveModal.vue?vue&type=script&lang=ts&"
export * from "./PostSaveModal.vue?vue&type=script&lang=ts&"
import style0 from "./PostSaveModal.vue?vue&type=style&index=0&id=147eb320&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147eb320",
  null
  
)

export default component.exports